/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * How a multiple choice answer turns into points. ALL_OR_NOTHING needs the complete key with nothing wrong ticked. PARTIAL awards in proportion and ignores wrong ticks, so ticking everything scores full marks. PARTIAL_WITH_PENALTY subtracts wrong ticks and stops at zero — a question never takes away points earned elsewhere.
 * @export
 * @enum {string}
 */

export const ScoringRuleDto = {
    AllOrNothing: 'ALL_OR_NOTHING',
    Partial: 'PARTIAL',
    PartialWithPenalty: 'PARTIAL_WITH_PENALTY'
} as const;

export type ScoringRuleDto = typeof ScoringRuleDto[keyof typeof ScoringRuleDto];



